<template>
  <!-- 帮助中心 -->
  <div class="helps">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['健康知识', $route.meta.title]"
    >
      <template slot="controls">
        <el-button type="primary" icon="el-icon-plus" @click="handleEdit('1')"
          >添加</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 90px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="ID"
        label="编号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Title"
        label="分类名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Class_List"
        label="级别"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Sort_Id"
        label="排序"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="viewDoc(scope.row)"
            >查看</el-button
          >
          <!-- <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="addDoc(scope.row)"
            >添加文章</el-button
          > -->
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="hadeleDetle(scope.row)"
            >删除</el-button
          >
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <!-- 编辑业务员信息 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">新增分类</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="100px"
            :rules="addFormRule"
            ref="addForm"
          >
            <el-form-item label="父级：" prop="Parent_Id">
              <el-input
                v-model="addForm.Parent_Id"
                clearable
                style="width: 300px"
                placeholder="请选择父级"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="标题：" prop="Title">
              <el-input
                v-model="addForm.Title"
                clearable
                style="width: 300px"
                placeholder="请输入标题"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="级别：" prop="Class_Layer">
              <!-- <el-input
                v-model="addForm.class_layer"
                clearable
                style="width: 300px"
                placeholder="请输入级别"
              >
              </el-input> -->
              <el-select v-model="addForm.Class_Layer" style="width: 300px">
                <el-option label="一级" value="1"> </el-option>
                <el-option label="二级" value="2"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排序：" prop="Sort_Id">
              <el-input
                v-model="addForm.Sort_Id"
                clearable
                style="width: 300px"
                placeholder="请输入排序"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="链接地址：" prop="Link_Url">
              <el-input
                v-model="addForm.Link_Url"
                clearable
                style="width: 300px"
                placeholder="请输入排序"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="图片：" prop="Img_Url">
              <upload
                @fileChange="uploadSortImg($event)"
                accept="image/jpg,image/jpeg,image/png"
                :multiple="true"
              ></upload>
              <img-view
                style="margin-left: 20px"
                :imgList="[{ url: addForm.img, id: 0 }]"
              ></img-view>
              <div>
                750px*400px，该图片显示模式为裁剪模式，主内容应显示在中间，两边为填充区
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submitForm">确定</el-button>
        <el-button type="info" @click="closeForm">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "helps",
  data() {
    return {
      /**表格数据 */
      // {
      //   id:"编号",
      //   name:"分类名称",
      //   level:"级别",
      //   sort:"排序"
      // }
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**新增drawer */
      addDrawer: false,
      /**新增分类表单 */
      addForm: {
        Id: "",
        Channel_Id: "19", //用户名 与 手机号保持一致
        Title: "", //密码
        Parent_Id: "",
        Class_Layer: "", //姓名
        Link_Url: "", //手机号
        Sort_Id: "", //部门
        Img_Url: "", //人员类型  固定值   2
        img: "",
        EntId: window.localStorage.getItem("entId"), //医生注册需要推荐人：业务员
      },
      addFormRule: {
        // PassWord: [mustFill],
        // ConfirmPassword: [mustFill],
        // Name: [mustFill],
        // areaValue: "",
        // Department: [mustFill], //部门/类型
        // RoleType: [mustFill],
        // IDNumber: [mustFill],
        // PriceLevel: [mustFill],
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    /**获取数据 */
    getTableData() {
      let data = {
        entId: window.localStorage.getItem("entId"),
        channel_Id: "19",
      };
      this.$request({
        method: "post",
        url: "Img/GetCategory",
        data: data,
      })
        .then((res) => {
          this.tableData = [];
          if (res.success) {
            this.tableData = res.list.map((item) => ({
              ID: item.ID,
              Title: item.Title,
              Class_List: item.Class_List,
              Sort_Id: item.Sort_Id,
              Channel_Id: item.Channel_Id,
              Parent_Id: item.Parent_Id,
              Link_Url: item.Link_Url,
            }));
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleEdit(row) {
      this.closeForm();
      if (row !== "1") {
        for (const key in this.addForm) {
          this.addForm[key] = row[key];
          this.addForm.Img_Url = row.Img_Url;
          this.addForm.img = this.$setImgUrl(row.Img_Url);
        }
      }
      this.addDrawer = true;
    },
    /**关闭drawer 清空表单信息 */
    closeForm() {
      for (let key in this.addForm) {
        this.addForm[key] = "";
      }
      this.addDrawer = false;
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },

    /**查看分类下文档 */
    viewDoc(row) {
      console.log(row, "111111111111");
      let prams = null;
      if (row) {
        prams = encodeURIComponent(
          JSON.stringify({ id: row.ID, channel_id: row.Channel_Id })
        );
      }
      this.$router.push({
        path: "knowleDoc",
        query: {
          prams: prams,
        },
      });
      prams = null;
    },

    //删除分类
    hadeleDetle(row) {
      this.$confirm("确定要删除吗?提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            entId: window.localStorage.getItem("entId"),
            keyIdList: row.id,
          };
          this.$request({
            url: "/Base/DltTableCategory",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getTableData();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    // 上传分类图片
    uploadSortImg(file) {
      if (file.length) {
        const formData = new FormData();
        formData.append("file", file[0]);
        this.$uploadRequest({
          method: "post",
          url: "admin/ashx/UploadImg.ashx?type=UploadFile&fileType=Navigation",
          data: formData,
        })
          .then((res) => {
            if (res.flag == 0) {
              this.addForm.Img_Url = res.message;
              this.addForm.img = this.$setImgUrl(res.message);
              this.$message.success("图片上传成功");
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    // 添加业务员
    /**提交表单 */
    submitForm() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            ID: this.addForm.ID,
            Channel_Id: this.addForm.Channel_Id,
            Title: this.addForm.Title,
            Parent_Id: this.addForm.Parent_Id,
            Class_Layer: this.addForm.Class_Layer,
            Link_Url: this.addForm.Link_Url,
            Sort_Id: this.addForm.Sort_Id,
            Img_Url: this.addForm.Img_Url,
            entId: window.localStorage.getItem("entId"),
          };
          console.log(data, "测试");
          this.$request({
            url: "/Base/SaveTableCategory",
            headers: {
              Auth: window.localStorage.getItem("auth"),
              ContentType: "application/json",
            },
            method: "post",
            data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.closeForm();
                this.handleRefresh();
              } else {
                //失败提示
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.helps {
  width: 100%;
  height: 100%;
}
</style>
